import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface LoadingWindowProps {
  message?: string;
  fullScreen?: boolean;
  overlay?: boolean;
  isWhite?: boolean;
}

const LoadingWindow = ({ 
  message = 'Loading...', 
  fullScreen = false,
  overlay = false,
  isWhite = false
}: LoadingWindowProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      p: 3,
      bgcolor: theme.palette.background.default,
      borderRadius: '16px',
      ...(fullScreen && {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }),
      ...(overlay && {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1
      })
    }}>
      <CircularProgress 
        size={24} 
        sx={{ color: isWhite ? 'white' : undefined }}
      />
      {message && (
        <Typography 
          variant="body2" 
          color={isWhite ? 'white' : 'text.secondary'}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingWindow; 